import { apiRequest } from '@/utils/api-request';
import {
  AutoGenerateEvalConfigRequest,
  AutoGenerateEvalConfigResponse,
} from '@/types/evals-types';

export const autoGenerateEvalConfig = async (
  body: AutoGenerateEvalConfigRequest,
): Promise<AutoGenerateEvalConfigResponse> => {
  const response = await apiRequest<AutoGenerateEvalConfigResponse>({
    url: '/evaluations/auto_generate_pass_fail_eval_config',
    target: 'platform',
    method: 'POST',
    body: body as unknown as Record<string, unknown>,
  });

  //trigger deploy - remove this after testing

  if (response.success === false) {
    throw new Error(response.detail);
  }

  return response?.data as AutoGenerateEvalConfigResponse;
};
